// extracted by mini-css-extract-plugin
module.exports = {"verticalDivider":"VerticalDivider_verticalDivider__VH1Xz"};